import type {FinishedResponseInteractionService} from 'shared/services';
import type {Loan} from 'src/typings';
import type {CancellationDataService} from '../../../loan/cancellation.data-service';

export class SearchedLoansService {
    public static serviceName = 'searchedLoansService';

    /*@ngInject*/
    constructor(private cancellationDataService: CancellationDataService,
                private finishedResponseInteractionService: FinishedResponseInteractionService) {
    }


    public async cancelLoan(loan: Loan) {
        try {
            const response = await this.cancellationDataService.cancelLoan(loan);
            await this.finishedResponseInteractionService.showSuccessResponseInToastIfPossible(response);
        } catch (e) {
            this.finishedResponseInteractionService.showFailedResponseInToast(e);
        }
    };
}